<template>
  <div class="container">
    <img class="backimg" src="../../public/image/index_pro.png" alt />
    <div class="con" >
      <swiper :options="swiperOptiona" ref="mySwipers" class="swiper" v-if="list.length">
        <swiper-slide class="item" v-for="(item,index) in list" :key="index" >
          <img :src="`http://ys.sansg.com/${item.picurl}`" alt  @click="gotoPro(item.id)"/>
          <div class="swiper_text">
            <p class="name">{{item.title}}</p>
            <p class="enname">{{item.description}}</p>
            <div class="arrow">
              <i class="iconfont icon-jiantou"></i>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="text">
        <p id="en2" class="en">
          <span>PRODUCT</span> 
          <span>&nbsp;CENTER</span>
        </p>
        <p v-show="isShow" class="title">
          <span>产品</span>
          <span>中心</span>
        </p>
      </div>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="btn wow fadeIn">
        <div class="prev">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="next">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  data() {
    return {
      lan: "",
      isShow: true,
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  props:['list','swiperOptiona'],
  mounted() {
    this.getLan();
    this.getShow();
    // console.log('list',this.list)
    // this.swiperOptiona.autoplay = false;
  },
  methods:{
    gotoPro(id){
      const link=`./proinfo.html?id=${id}`
      window.open(link,'_self')
    },
    getLan() {
      this.lan = localStorage.getItem("language");
    },
    getShow() {
      if(this.lan=='zh-CN'){
        this.isShow = true;
      }else{
        this.isShow = false;
        $('#en2').addClass('title');
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  position: relative;
  .backimg {
    width: 100%;
    display: block;
    object-fit: contain;
  }
  .con {
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
    overflow-x: hidden;
    .swiper {
      position: absolute;
      top: 15%;
      // transform: translateY(-50%);
      right: -150px;
      width: 75%;
      .item {
        position: relative;
        overflow: hidden;
        cursor: pointer;
        transition: all 600ms;
        &:hover{
          border-radius: 0 140px 0 140px;
          .swiper_text{
            p{
              color: #008cd6ff;
            }
            .arrow{
              transform: translateX(20px);
              i{
                color: #008CD6FF;
                &::after{
                  background-color: #008CD6FF;
                }
              }
            }
          }
        }
        img {
          display: block;
          object-fit: contain;
          width: 100%;
          transition: all 600ms;
        }
        .swiper_text {
          position: absolute;
          top: 40px;
          left: 40px;
          p {
            font-family: "SOURCEHANSANSCN-NORMAL";
            transition: all 600ms;
          }
          .name {
            font-size: 20px;
            color: black;
          }
          .enname {
            font-size: 16px;
            color: #9a9a9aff;
            margin-top: 16px;
          }
          .arrow {
            transition: all 600ms;
            margin-top: 80px;
            i {
              color: white;
              font-size: 16px;
              position: relative;
              margin-left: 61px;
              transition: all 600ms;
              &::after {
                display: inline-block;
                content: "";
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: -55px;
                width: 64px;
                height: 1px;
                background-color: white;
                transition: all 600ms;
              }
            }
          }
        }
      }
    }
    .text {
      position: absolute;
      top: 20%;
      //   transform: translateY(-50%);
      left: 7%;
      .en {
        color: #ddddddff;
        font-family: "SOURCEHANSANSCN-NORMAL";
        font-size: 40px;
      }
      .title {
        position: relative;
        padding-bottom: 30px;
        span {
          font-family: "SOURCEHANSANSCN-BOLD";
          font-size: 36px;
        }
        span:nth-child(1) {
          color: #30aa89ff;
        }
        span:nth-child(2) {
          color: #008cd6ff;
        }
        &::after {
          display: inline-block;
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 60px;
          height: 1px;
          background: linear-gradient(
            0deg,
            rgba(48, 170, 137, 1) 0%,
            rgba(0, 140, 214, 1) 100%
          );
        }
      }
    }
    .btn {
      position: absolute;
      bottom: 20%;
      left: 7%;
      display: flex;
      .prev,
      .next {
        border-radius: 50%;
        border: 2px solid #999999ff;
        position: relative;
        width: 54px;
        height: 54px;
        margin-right: 30px;
        cursor: pointer;
        outline: none;
        &:hover {
          i {
            font-size: 24px;
          }
        }
        i {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 20px;
          transition: all 300ms;
        }
      }
    }
  }
}
@media screen and (max-width:1000px) {
  .container{
    .backimg{
      height: 550px;
      object-fit: cover;
    }
    .con{
      .swiper{
        top: 35%;
        width: 90%;
        left: 5%;
        right: unset;
        .item{
          &:hover{
            border-radius: unset;
          }
          .swiper_text{
            top: 10px;
            left: 10px;
            .name{
              font-size: 12px;
            }
            .enname{
              font-size: 12px;
              margin-top: 5px;
            }
            .arrow{
              display: none;
            }
          }
        }
      }
      .text{
        top: 10%;
        .en{
          font-size: 20px;
        }
        .title{
          padding-bottom: 10px;
          span{
            font-size: 18px;
          }
        }
      }
      .btn{
        left: unset;
        right: 7%;
        top: 10%;
        justify-content: space-between;
        .prev,.next{
          width: 30px;
          height: 30px;
          border: 1px solid #999999ff;
          margin-right: unset;
          margin-left: 20px;
          i{
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
<style scoped>
.swiper-pagination {
  width: 100px;
  left: unset;
  right: 5%;
  bottom: 45px;
  font-family: "DINEngschriftStd";
  color: #999999ff;
  font-size: 16px;
}
</style>